import { getCanonicalUrl, normalizeCanonicalPath } from "./seo";
import seoPagesJson from "./seoPages.json";

export interface SeoPageConfig {
  path: string;
  title: string;
  description: string;
  introTitle: string;
  introBody: string;
  regionIds?: string[];
  relatedPaths?: string[];
  priority?: string;
}

export interface SeoPageStructuredData {
  "@context": "https://schema.org";
  "@type": "WebPage";
  name: string;
  description: string;
  url: string;
  isPartOf: {
    "@type": "WebSite";
    name: "howisthe.surf";
    url: string;
  };
}

export const seoPages = seoPagesJson as SeoPageConfig[];

export function getSeoPageByPath(pathname: string): SeoPageConfig | null {
  const normalizedPath = normalizeCanonicalPath(pathname);

  return (
    seoPages.find((page) => normalizeCanonicalPath(page.path) === normalizedPath) ?? null
  );
}

export function buildSeoPageStructuredData(page: SeoPageConfig): SeoPageStructuredData {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: page.title,
    description: page.description,
    url: getCanonicalUrl(page.path),
    isPartOf: {
      "@type": "WebSite",
      name: "howisthe.surf",
      url: getCanonicalUrl("/"),
    },
  };
}
